// extracted by mini-css-extract-plugin
module.exports = {"selectors-container":"style_selectors-container__2Lixp"};